import React, { Component } from 'react';

export default class TourSlide extends Component {
  render() {
    return (
      <div className="Tour__slide">
        <img className="Tour__image" src={'/assets/' + this.props.image} alt="" />

        <div className="Tour__highlight" style={{
          width: this.props.highlightWidth + 'px',
          height: this.props.highlightHeight + 'px',
          transform: `translate3d(${this.props.highlightPosX}px, ${this.props.highlightPosY}px, 0)`
        }}></div>

        <div className="Tour__text-block" style={{
          width: this.props.textWidth + 'px',
          minHeight: this.props.textHeight + 'px',
          transform: `translate3d(${this.props.textPosX}px, ${this.props.textPosY}px, 0)`
        }}>

          {this.props.displayLogo && <div style={{ textAlign: 'center' }}><img src={this.props.logoUrl} alt="" /></div>}

          <h2 className="Tour__title">{this.props.title}</h2>
          <p className="Tour__content">
            {this.props.content.split('\n').map((item, key) => {
              return <span key={key}>{item}<br/></span>
            })}
          </p>

          <button type="button" onClick={this.props.doPrevStep}
            disabled={!this.props.hasPrevButton}>
            Back
          </button>
          {!this.props.hasFinishButton && <button type="button" onClick={this.props.doNextStep}
            disabled={!this.props.hasNextButton}>
            Next
          </button>}

          {this.props.hasFinishButton && <button type="button" className="primary" onClick={this.props.doFinishStep}>
            Finish
          </button>}

          <span className="Tour__step-counter">{this.props.currentStep} / {this.props.maxSteps}</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TourSlide.js